/**
 * Set login state from id token
 */
export function doLogin (idToken) {
  return async function (dispatch) {
    // TODO not doing anything atm, but needed later to get
    // api token and account status from crea api
  }
}
